import { BASE_GROWTH_IMAGE_CDN, FIRST_DASH_PATH } from '../../../constants'

export const IOS = 'comdoordashdriver://'
export const ANDROID = 'dddriver://'
export const CLOSE = 'onboarding/completed'
export const DASH_NOW_IOS = 'onboarding/dash-now'
export const DASH_NOW_ANDROID = 'first-dash/dash-now'
export const SCHEDULE_IOS = 'onboarding/schedule'
export const SCHEDULE_ANDROID = 'first-dash/schedule'
export const HELP_URL = 'https://help.doordash.com'

export enum DasherObjectFields {
  RewardsTier = 'rewards_tier',
  DefaultStartingPoint = 'default_starting_point',
}

export const BUSY_IMG_URL = `${BASE_GROWTH_IMAGE_CDN}${FIRST_DASH_PATH}/busy-heatmap-dash/en.png`

export const SCHEDULE_DASH_IMG_URL = `${BASE_GROWTH_IMAGE_CDN}${FIRST_DASH_PATH}/schedule.png`

export const DASH_IMG_URL = `${BASE_GROWTH_IMAGE_CDN}${FIRST_DASH_PATH}/dash.png`
